import React, {
    useCallback,
    useContext,
    useEffect,
    useMemo,
    useRef,
    useState,
} from "react";
import { mineData, SERVER_URL, MAPS_API, axiosBaseInstance } from "../data";
import "chart.js/auto";
// import { Line } from "react-chartjs-2";
import { Map, GoogleApiWrapper, Marker } from "google-maps-react";
import Card from "../components/Card";
import Card2 from "../components/Card2";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Navbar from "../components/Navbar";
import Spinner from "../components/Spinner";
import VolUploadModal from "../widgets/Modal";
import { GeoDataChart } from "../widgets/HighCharts";
import ChartContext from "../context/ChartContext";
import Toolbar from "../components/Toolbar";
import markerIcon from "../Markers/pin.png";
import Hamburg from "../components/Hamburger";
import LatLng from "../widgets/LatLng";
import SelectedAltitude from "../widgets/SelectedAltitude";
import DrawingLabelModal from "../components/DrawingLabelModal";
import styles from "./MapPage.module.css";
import { TopNav } from "../components/TopNav";
import Draggable from "react-draggable";
import { FaHamburger } from "react-icons/fa";
import SiteContext from "../context/SiteContext";
import DashboardContext from "../context/DashboardContext";
import { shade } from "../utils/shade";
import ElevationProfile from "../widgets/D3Chart";
// import { Box, Modal } from "@mui/material";
// import CompareVolumeModal from "../components/CalculateVolumeModal";
// import CalculateVolumeModal from "../components/CalculateVolumeModal";
// import ContourCreationModal from "../components/ContourCreationModal";

const mapStyles = {
    width: "100%",
    height: "100%",
    position: "relative",
};

const skeletonChartData = {
    labels: [],
    datasets: [
        {
            label: "Cut Volume",
            data: [],
            fill: true,
            borderColor: "rgba(75,192,192,1)",
        },
        {
            label: "Fill Volume",
            data: [],
            fill: true,
            borderColor: "#742774",
        },
        {
            label: "Total Volume",
            data: [],
            fill: true,
            borderColor: "#FD7272",
        },
    ],
};

const modalStyle = {
    outline: "none",
    position: "absolute",
    top: "50%",
    left: "50%",
    minHeight: "25%",
    transform: "translate(-50%, -50% )",
    width: "60%",
    minWidth: "500px",
    borderRadius: 1,
    bgcolor: "background.paper",
    p: 4,
};

const MapPage = (props) => {
    const { id="3", idx=0 } = useParams();
    // const id = "3";
    // const idx = 0;
    const [detectChange, setDetectChange] = useState(false);
    const [currMapData, setCurrMapData] = useState({});
    const [map, setMap] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [contours, setContours] = useState([]);
    const [isCollapsed, setIsCollapsed] = useState(true);
    const mapRef = useRef(null);
    const navigate = useNavigate();
    const [contourPath, setContourPath] = useState([]);
    const [compareData, setCompareData] = useState([]);
    const [coords, setCoords] = useState([]);
    const [segIdx, setSegIdx] = useState(0);
    const [withinSegVolume, setWithinSegVolume] = useState(null);
    const [volCalcType, setVolCalcType] = useState("min-height");
    const [chartData, setChartData] = useState({ ...skeletonChartData });
    const [modalType, setModalType] = useState(null);
    const [volumeData, setVolumeData] = useState(null);
    const lineRef = useRef(null);
    const { setControlTabIndex } = useContext(DashboardContext);
    const [isDistGraph, setIsDistGraph] = useState(false);

    // Drawing states
    const drawingManagerRef = useRef(null);
    const [currentShape, setCurrentShape] = useState(null);
    const [popupVisible, setPopupVisible] = useState(false);
    const [label, setLabel] = useState("");
    const [color, setColor] = useState("#ff0000");
    const [fillColor, setFillColor] = useState("#ff0000");
    const [properties, setProperties] = useState([{ key: "", value: "" }]);
    const [drawingProps, setDrawingProps] = useState([]);
    const infoWindowRef = useRef(null);
    const [fillOpacity, setFillOpacity] = useState(0.3);
    const [strokeOpacity, setStrokeOpacity] = useState(1);
    const [strokeWeight, setStrokeWeight] = useState(2);
    const [drawnShapes, setDrawnShapes] = useState([]);
    const [geoDrawings, setGeoDrawings] = useState({
        polygons: [],
        polylines: [],
        points: [],
    });

    // const contourPath = mineData.find;
    // const contourPath = ["output1.geojson", "output2.geojson"];
    const hoverOn = useRef(false);
    const [area, setArea] = useState(null);
    const [customHeight, setCustomHeight] = useState(0);
    const [loading, setLoading] = useState(false);
    const [geoData, setGeoData] = useState(null);
    const [checkedRadio, setCheckedRadio] = useState(0);
    const [checkedRadioMap, setCheckedRadioMap] = useState(0);
    const [savedPolyPoints, setSavedPolyPoints] = useState({
        polylines: [],
        polygons: [],
    });
    const [createdContours, setCreatedContours] = useState({
        1: {
            "9th Visit": {
                20: "1709626448_553.geojson",
            },
        },
    });
    const [currMapTypeIndex, setCurrMapTypeIndex] = useState(sessionStorage.getItem("visit") ?? 0);

    const [contourInterval, setContourInterval] = useState(0);

    const [segmentVolume, setSegmentVolume] = useState(null);
    const selectOrthoRef = useRef(null);
    const [topoOverlays, setTopoOverlays] = useState([]);
    const [orthoMapOpacity, setOrthoMapOpacity] = useState(1.0);
    const [DSMMapOpacity, setDSMMapOpacity] = useState(1.0);
    const [DTMMapOpacity, setDTMMapOpacity] = useState(1.0);
    const [elevCoords, setElevCoords] = useState([]);
    const { hoveredValue } = useContext(ChartContext);
    const [resHeights, setResHeights] = useState([]);
    const [layerIndicator, setLayerIndicator] = useState("elevation"); // elevation / Contour / volume / topo
    const { setCurrLatLng } = useContext(SiteContext);
    const [clickedLatLng, setClickedLatLng] = useState({ lat: 0, lng: 0 });
    const [currPointHeight, setCurrPointHeight] = useState(0);
    const [pointHeightActive, setPointHeightActive] = useState(false);
    const location = useLocation();
    const [googleObj, setGoogleObj] = useState(null);
    const hasSetMouseMove = useRef(null);
    const [toolIndex, setToolIndex] = useState(-1)

    const getCurrentPointHeight = (params, lat, lng) => {
        axiosBaseInstance
            .post(
                "/get-one-height",
                {
                    lat,
                    lng,
                    site: params.name,
                    tifVisit: params?.tifPaths[currMapTypeIndex],
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            )
            .then((res) => {
                setCurrPointHeight(res.data.alt);
                setClickedLatLng({ lat, lng });
                const marker = new props.google.maps.Marker({
                    position: { lat, lng },
                    map: map,
                    icon: {
                        url: "/assets/icons/survey.png",
                        scaledSize: new props.google.maps.Size(50, 50),
                        anchor: new props.google.maps.Point(25, 50),
                    },
                    label: {
                        text: `${res.data.alt.toFixed(2)} m`,
                        color: "black",
                        fontSize: "14px",
                        fontWeight: "bold",
                    },
                });
            })
            .catch((err) => {
                console.log(err.message);
                setCurrPointHeight(0);
            });
    };

    function toDMS(deg) {
        const absolute = Math.abs(deg);
        const degrees = Math.floor(absolute);
        const minutesNotTruncated = (absolute - degrees) * 60;
        const minutes = Math.floor(minutesNotTruncated);
        const seconds = ((minutesNotTruncated - minutes) * 60).toFixed(2);

        return `${degrees}° ${minutes}' ${seconds}"`;
    }

    const getSegmentVolume = async (idx) => {
        try {
            const resp = await axiosBaseInstance.post(
                `/segment/vol`,
                {
                    site: currMapData.name,
                    ogl: currMapData.volumeSegments[window.currentMapTypeIndex]
                        .ogls[idx],
                    stock: currMapData.volumeSegments[
                        window.currentMapTypeIndex
                    ].stockraw[idx],
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );
            setSegIdx(idx);
            const result = await resp.data;
            setSegmentVolume(result);
        } catch (error) {
            console.log(error.message);
            setSegmentVolume([false, false]);
        }
    };

    const fetchHeights = async () => {
        try {
            const resp = await axiosBaseInstance.post(
                `/get-height`,
                {
                    site: currMapData.name,
                    tifVisit: currMapData.tifPaths[currMapTypeIndex],
                    coords: elevCoords,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );
            const result = await resp.data;
            setResHeights(result);
        } catch (error) {
            console.log(error.message);
        }
    };

    const removeContour = () => {
        mapRef.current.map.data.forEach((feature) => {
            mapRef.current.map.data.remove(feature);
        });
    };

    useEffect(() => {
        const hasReloaded = sessionStorage.getItem("reloaded");
        if (!hasReloaded) {
            sessionStorage.setItem("reloaded", "true");
            window.location.reload();
        } else {
            sessionStorage.removeItem("reloaded");
            sessionStorage.setItem("visit", currMapTypeIndex)
        }
    }, [location.pathname]);

    useEffect(() => {
        if (lineRef.current) {
            lineRef.current.render();
            lineRef.current.update();
        }
    }, [chartData]);

    const createContour = async (contourPath, color) => {
        setLoading(true);
        removeContour();
        const p = new Promise((res) => {
            setTimeout(() => {
                mapRef.current.map.data.loadGeoJson(
                    `${currMapData.root}/${contourPath}`
                );
                mapRef.current.map.data.setStyle({
                    strokeColor: color,
                    strokeWeight: 1,
                });
                res(true);
            }, 500);
        });
        p.then(() => {
            setLoading(false);
        });
    };

    const renderContour = async (fileName) => {
        setLoading(true);
        removeContour();
        const p = new Promise((res) => {
            setTimeout(() => {
                mapRef.current.map.data.loadGeoJson(
                    `${SERVER_URL}/static/geojsons/${fileName}`
                );
                mapRef.current.map.data.setStyle({
                    strokeColor: "white",
                    strokeWeight: 1,
                });
                res(true);
            }, 500);
        });
        p.then(() => {
            setLoading(false);
        });
    };

    const handleClickOnExportPDF = () => {
        const data = {
            id,
            volumeData: {
                cut_volume: 2483,
                fill_volume: 45435,
                total_volume: 478453,
            },
            visitId: window.currentMapTypeIndex,
        };
        const query = new URLSearchParams(data).toString();
        navigate("/pdf?" + query, {
            state: { coords, ...data },
        });
    };

    const hideCard = () => {
        document.querySelector(".card_container").classList.toggle("closed");
        setIsCollapsed(!isCollapsed);
    };

    const calculateVolumeWithinSegmet = async () => {
        setLoading(true);
        try {
            const bodyy = {
                site: currMapData.name,
                ogl: currMapData.volumeSegments[window.currentMapTypeIndex]
                    .ogls[segIdx],
                stock: currMapData.volumeSegments[window.currentMapTypeIndex]
                    .stockraw[segIdx],
                polys: coords,
            };

            const resp = await axiosBaseInstance.post(
                `/segment/within`,
                bodyy,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            const result = await resp.data;
            setWithinSegVolume(result);
            setLoading(false);
        } catch (error) {
            console.log(error.message);
            setLoading(false);
            setWithinSegVolume([false, false]);
        }
    };

    const calculateVolume = async () => {
        const body = {
            poly_coords: coords,
            baseValue: customHeight,
            type: volCalcType,
            visit: currMapData.visits[window.currentMapTypeIndex],
        };
        setVolumeData(null);
        setLoading(true);
        try {
            const { data } = await axiosBaseInstance.post(`/vol/${id}`, body, {
                timeout: 60000,
            });
            if (data.status === "success") {
                setLoading(false);
                const tempVol = {
                    cut_volume: data.data.cut_volume * 1,
                    fill_volume: data.data.fill_volume * 1,
                    total_volume:
                        data.data.cut_volume * 1 + data.data.fill_volume * 1,
                };
                setVolumeData(tempVol);
            } else if (data.status === "failure") {
                alert(data.message);
                setLoading(false);
            }
        } catch (err) {
            setLoading(false);
            alert(err.toString());
        }
    };

    const addContour = async () => {
        if (contourInterval <= 0) alert("please enter valid interval");
        const body = {
            interval: contourInterval,
            visit: currMapData.visits[window.currentMapTypeIndex],
        };
        if (
            createdContours &&
            createdContours[id] &&
            createdContours[id][
                currMapData.visits[window.currentMapTypeIndex]
            ] &&
            createdContours[id][currMapData.visits[window.currentMapTypeIndex]][
                contourInterval
            ]
        )
            return alert("contour already present");
        // const body = {
        //   poly_coords: coords,
        //   baseValue: customHeight,
        //   type: volCalcType,
        //   visit: currMapData.visits[window.currentMapTypeIndex],
        // };
        // setVolumeData(null);
        setLoading(true);
        try {
            const { data } = await axiosBaseInstance.post(`/cont/${id}`, body, {
                timeout: 60000,
            });
            if (data.status === "success") {
                setLoading(false);
                closeModal();
                // const link = document.createElement("a");
                // link.target = "_blank";
                // link.href = `${SERVER_URL}${data.data.name}`;
                // document.body.appendChild(link);
                // link.click();
                // document.body.removeChild(link);
                let len = 0;
                setCreatedContours((prevState) => {
                    // 1: {
                    //   "9th Visit": {
                    //     20: "1709626448_553.geojson",
                    //   },
                    // },
                    // let temp = { [contourInterval]: data.data.name };
                    // createdContours[id][currMapData.visits[window.currentMapTypeIndex]][contourInterval]
                    let temp = { ...prevState };
                    if (!temp[id]) {
                        temp[id] = {};
                    }
                    if (
                        !temp[id][
                            currMapData.visits[window.currentMapTypeIndex]
                        ]
                    ) {
                        temp[id][
                            currMapData.visits[window.currentMapTypeIndex]
                        ] = {};
                    }
                    temp[id][currMapData.visits[window.currentMapTypeIndex]][
                        contourInterval
                    ] = data.data.name;
                    // len = Object.keys(temp[id][currMapData.visits[window.currentMapTypeIndex]]).length
                    len = Object.keys(
                        temp[id][currMapData.visits[window.currentMapTypeIndex]]
                    ).indexOf(contourInterval);
                    localStorage.setItem("contours", JSON.stringify(temp));
                    return temp;
                    // return { ...prevState, ...temp };
                });
                setTimeout(() => {
                    setCheckedRadio(len + 3);
                }, 10);
                renderContour(data.data.name);
            } else if (data.status === "failure") {
                alert(data.message);
                setLoading(false);
            }
        } catch (err) {
            setLoading(false);
            alert(err.toString());
        }
    };

    const compareVolumes = async () => {
        const tempChartData = {
            labels: [],
            datasets: [
                {
                    ...chartData.datasets[0],
                    data: [],
                },
                {
                    ...chartData.datasets[1],
                    data: [],
                },
                {
                    ...chartData.datasets[2],
                    data: [],
                },
            ],
        };
        // return
        if (compareData < 2 || coords.length < 3) {
            return;
        }
        const body = {
            poly_coords: coords,
            baseValue: customHeight,
            type: volCalcType,
            visits: compareData,
        };
        setLoading(true);
        try {
            const { data: respData } = await axiosBaseInstance.post(
                `/vol/${id}/compare`,
                body,
                { timeout: 60000 }
            );
            if (respData.status === "success") {
                respData["data"]
                    ? respData["data"].map((el) => {
                          tempChartData.labels.push(el.visit);
                          tempChartData.datasets[0].data.push(
                              el.volume.cut_volume
                          );
                          tempChartData.datasets[1].data.push(
                              el.volume.fill_volume
                          );
                          tempChartData.datasets[2].data.push(
                              el.volume.cut_volume * 1 +
                                  el.volume.fill_volume * 1
                          );
                          return el.visit;
                      })
                    : alert(respData.message || "Something went wrong");
                setLoading(false);
                setChartData(tempChartData);
            } else if (respData.status === "failure") {
                alert(respData.message);
                setLoading(false);
            }
        } catch (err) {
            setLoading(false);
            alert(err.toString());
        }
    };

    const openModal = () => {
        setModalOpen(true);
    };

    const closeModal = () => {
        setModalOpen(false);
        // setModalType(null);
        // setVolumeData(null);
        // setCompareData([]);
        // setContourInterval(0);
        // setChartData({
        //   labels: [],
        //   datasets: [
        //     {
        //       ...chartData.datasets[0],
        //       data: [],
        //     },
        //     {
        //       ...chartData.datasets[1],
        //       data: [],
        //     },
        //     {
        //       ...chartData.datasets[2],
        //       data: [],
        //     },
        //   ],
        // });
        // setVolCalcType("min-height");
        // setCustomHeight(0);
    };

    //-------------------------- Drawing Functions ------------------------
    const getPosition = (shape) => {
        if (shape.getPath) return shape.getPath().getAt(0);
        if (shape.getBounds) return shape.getBounds().getCenter();
        return map.getCenter();
    };

    const buildTableHTML = (label, properties, from = null) => {
        let html = `<div class="draw-info-window" style="width: ${
            from ? "100%" : "250px"
        }; background:var(--primary-1);"><b style="
                        font-size: 18px; color:var(--secondary-2);
                    ">${label}</b><br><table style="border-collapse:collapse;margin-top:5px;width: 100%;font-size: 12px; border:1px solid var(--secondary-2);"><tbody style="
                    ">`;
        properties.forEach((prop) => {
            if (prop.key.trim()) {
                html += `<tr style="/* padding:8px; */text-align:start;"><td style="
                            padding: 4px; color:var(--secondary-2); font-weight:bold;
                        "><b>${prop.key}</b></td><td style="
                            padding: 4px;
                            color:var(--secondary-2);
                        ">${prop.value}</td></tr>`;
            }
        });
        html += `</tbody></table></div>`;
        return html;
    };

    const handleCancel = () => {
        if (currentShape) {
            currentShape.overlay.setMap(null);
        }
        setLabel("");
        setColor("#ff0000");
        setFillColor("#ff0000");
        setProperties([{ key: "", value: "" }]);
        setCurrentShape(null);
        setPopupVisible(false);
    };

    const handleSave = () => {
        if (!currentShape) return;
        if (label.trim().length === 0) return;
        // if(!properties.label) return;

        currentShape.overlay.setOptions({
            strokeColor: color,
            fillColor: fillColor,
            fillOpacity,
            strokeOpacity,
            strokeWeight,
        });

        const position = getPosition(currentShape.overlay);

        if (!infoWindowRef.current) {
            infoWindowRef.current = new props.google.maps.InfoWindow();
        }

        currentShape.overlay.addListener("mouseover", () => {
            infoWindowRef.current.setContent(buildTableHTML(label, properties));
            infoWindowRef.current.setPosition(position);
            infoWindowRef.current.open(map);
        });

        currentShape.overlay.addListener("mouseout", () => {
            infoWindowRef.current.close();
        });

        setDrawingProps((prev) => {
            return [
                ...prev,
                {
                    label,
                    properties,
                    position,
                    shape: currentShape.overlay,
                    type: currentShape.type,
                    visible: true,
                },
            ];
        });
        // setDrawnShapes(prev=> [...prev, {shape:currentShape, label}])

        // Reset popup state
        setPopupVisible(false);
        setLabel("");
        setColor("#ff0000");
        setFillColor("#ff0000");
        setProperties([{ key: "", value: "" }]);
        setCurrentShape(null);
    };

    const handleClickFromList = (label, properties, position) => {
        if (!infoWindowRef.current) {
            infoWindowRef.current = new props.google.maps.InfoWindow();
        }
        infoWindowRef.current.setContent(buildTableHTML(label, properties));
        infoWindowRef.current.setPosition(position);
        infoWindowRef.current.open(map);
        map.setCenter(position);
        map.setZoom(17);
    };

    const handlePropertyChange = (index, field, value) => {
        const newProps = [...properties];
        newProps[index][field] = value;
        setProperties(newProps);
    };

    const addProperty = () => {
        setProperties([...properties, { key: "", value: "" }]);
    };

    const removeProperty = (index) => {
        const newProps = [...properties];
        newProps.splice(index, 1);
        setProperties(newProps);
    };

    const deleteDrawing = (label) => {
        setDrawingProps((prev) => {
            // TODO: use temp var
            const idx = prev.findIndex((prop) => prop.label === label);
            const toBeDeleted = prev.splice(idx, 1);
            toBeDeleted[0].shape.setMap(null);
            return [...prev];
        });
        if (infoWindowRef.current) {
            infoWindowRef.current.close();
        }
    };

    const toggleDrawingVisibility = (label) => {
        setDrawingProps((prev) => {
            const newProps = [...prev];
            const index = newProps.findIndex((prop) => prop.label === label);
            const drawing = newProps[index];
            if (drawing.shape) {
                if (drawing.visible) {
                    drawing.shape.setOptions({
                        fillOpacity: 0,
                        strokeOpacity: 0,
                    });
                } else {
                    drawing.shape.setOptions({
                        fillOpacity: 0.3,
                        strokeOpacity: 1,
                    });
                }
                drawing.visible = !drawing.visible;
            }
            return newProps;
        });
    };

    const makeDrawingFromJSON = (pth, google, map, color) => {
        // axiosBaseInstance.get("")

        axiosBaseInstance.get(`${pth}`).then((res) => {
            let drawingInFocus = null;
            let hasPoints = false;
            for (let feature of res.data.features) {
                if (feature.geometry.type === "LineString") {
                    const latlng = feature.geometry.coordinates.map((el) => ({
                        lat: el[1],
                        lng: el[0],
                    }));
                    const polyline22 = new google.maps.Polyline({
                        path: latlng,
                        geodesic: true, // optional: makes it follow Earth's curvature
                        strokeColor: color,
                        strokeOpacity: 1.0,
                        strokeWeight: 2,
                        map: map,
                    });
                    window.drawnFeatures.push({
                        pth,
                        drawing: polyline22,
                        type: "Polyline",
                    });
                    setGeoDrawings((prev) => ({
                        ...prev,
                        drawnFeatures: window.drawnFeatures,
                        position: getPosition(polyline22),
                    }));
                    drawingInFocus = polyline22;
                } else if (feature.geometry.type === "Polygon") {
                    const latlng = feature.geometry.coordinates[0].map(
                        (el) => ({ lat: el[1], lng: el[0] })
                    );
                    const polygon22 = new google.maps.Polygon({
                        paths: latlng,
                        strokeColor: color,
                        strokeOpacity: 0.8,
                        strokeWeight: 2,
                        fillColor: "red",
                        fillOpacity: 0.35,
                        map: map,
                    });
                    window.drawnFeatures.push({
                        pth,
                        drawing: polygon22,
                        type: "Polygon",
                        position: getPosition(polygon22),
                    });
                    setGeoDrawings((prev) => ({
                        ...prev,
                        drawnFeatures: window.drawnFeatures,
                    }));
                    drawingInFocus = polygon22;
                } else {
                    const point22 = new google.maps.Marker({
                        position: {
                            lat: feature.geometry.coordinates[1],
                            lng: feature.geometry.coordinates[0],
                        },
                        map: map,
                        title: res.data.name, // optional: shows on hover
                    });
                    window.drawnFeatures.push({
                        pth,
                        drawing: point22,
                        type: "Point",
                    });
                    setGeoDrawings((prev) => ({
                        ...prev,
                        drawnFeatures: window.drawnFeatures,
                    }));
                    hasPoints = true;
                }
            }
            if (drawingInFocus && !hasPoints) {
                const currPosi = getPosition(drawingInFocus);
                map.setCenter(currPosi);
                map.setZoom(20);
            }else{
                map.setZoom(15)
            }
        });
    };

    // ----------------------------------------------------------------------

    const togglePointHeightActive = () => {
        window.pointHeightActive = !window.pointHeightActive;
        setPointHeightActive(window.pointHeightActive);
        window.resetPolys();
    };

    useEffect(() => {
        setControlTabIndex(1);
        try {
            const mapParams = mineData.find((el) => el.id == id);
            setCurrMapData(mapParams);
            setContourPath(mapParams.geoPaths);
            // props.setNavTitle(mapParams);
            const map = mapRef.current.map;
            window.currentMapTypeIndex = sessionStorage.getItem("visit") ?? 0;
            window.currentMapType = "orthoPaths";
            window.pointHeightActive = false;
            let drawingManager = null;
            let drawnPolygons = [];
            let drawnPolylines = [];
            map.setMapTypeId("satellite");
            map.setOptions(
                map.setOptions({
                    draggableCursor: "crosshair", // cursor on hover
                    draggingCursor: "grabbing", // cursor while dragging (optional)
                })
            );
            setMap(map);
            const google = props.google;

            const getHeightEvent = map?.addListener("click", (e) => {
                if (!window.pointHeightActive){
                    return;
                } 
                getCurrentPointHeight(
                    mapParams,
                    e.latLng.lat(),
                    e.latLng.lng()
                );
            });

            var mapBounds = new google.maps.LatLngBounds(
                new google.maps.LatLng(
                    mapParams.mapBounds.lat1,
                    mapParams.mapBounds.lng1
                ),
                new google.maps.LatLng(
                    mapParams.mapBounds.lat2,
                    mapParams.mapBounds.lng2
                )
            );
            map.fitBounds(mapBounds);
            // map.setZoom()
            // map.setCenter(mapParams.location);
            if (geoData) {
                // features = map.data.addGeoJson(geoData)
            }

            window.setCenter = (center) => {
                map.setCenter(center);
            };

            window.recenter = () => {
                map.fitBounds(mapBounds);
            };
            async function getGeoData() {
                try {
                    // if(drawnPolygons.length > 0 || drawnPolylines.length > 0) window.removeDrawnPoly();
                    // const resp = await fetch("http://localhost:4000/geo/"+id);
                    // const {polygons, polylines} = await resp.json();
                    const resp = localStorage.getItem("polyFeatures") ?? "[]";
                    const curPolyData = JSON.parse(resp).find(
                        (el) => el.id == id
                    );
                    if (curPolyData) {
                        const { polygons, polylines } = curPolyData;
                        // setGeoData(geoParams)
                        for (let i = 0; i < polygons.features.length; i++) {
                            const polygon = new google.maps.Polygon({
                                path: polygons.features[
                                    i
                                ].geometry.coordinates.map((latlng) => ({
                                    lat: latlng[1],
                                    lng: latlng[0],
                                })),
                                strokeColor: "#FF0000",
                                strokeOpacity: 0.8,
                                strokeWeight: 2,
                                id: i + 1,
                            });
                            polygon.setMap(map);
                            drawnPolygons.push(polygon);
                        }
                        for (let i = 0; i < polylines.features.length; i++) {
                            const polyline = new google.maps.Polyline({
                                path: polylines.features[
                                    i
                                ].geometry.coordinates.map((latlng) => ({
                                    lat: latlng[1],
                                    lng: latlng[0],
                                })),
                                strokeColor: "blue",
                                strokeOpacity: 0.8,
                                strokeWeight: 2,
                                id: i + 1,
                            });
                            polyline.setMap(map);
                            drawnPolylines.push(polyline);
                        }
                        setSavedPolyPoints({
                            polygons: drawnPolygons,
                            polylines: drawnPolylines,
                        });
                    }
                } catch (error) {
                    alert(error.message);
                }
            }
            // getGeoData();

            // map.data.loadGeoJson('/assets/mapdata2.geojson')

            const drawnFeatures = [];
            const drawnFeatures1 = [];
            window.drawnFeatures = [];

            const initDrawingManager = () => {
                if (map && props.google) {
                    drawingManager =
                        new props.google.maps.drawing.DrawingManager({
                            // drawingMode: "google.maps.drawing.OverlayType.POLYGON",
                            drawingControl: window.drawingStart,
                            drawingControlOptions: {
                                position:
                                    props.google.maps.ControlPosition.TOP_LEFT,
                                drawingModes: [
                                    "polyline",
                                    "polygon",
                                    "rectangle",
                                    "circle",
                                ],
                            },
                            polygonOptions: {
                                editable: true,
                                // fillOpacity: 0.3
                            },
                            rectangleOptions: {
                                editable: true,
                                // fillOpacity: 0.3
                            },
                        });

                    drawingManager.setMap(map);
                    drawingManagerRef.current = drawingManager;

                    google.maps.event.addListener(
                        drawingManager,
                        "overlaycomplete",
                        (event) => {
                            console.log(event);
                            drawingManager.setDrawingMode(null);
                            setCurrentShape(event);
                            setPopupVisible(true);
                        }
                    );
                }
            };

            window.exportGeoJson = () => {
                const geoJson = {
                    type: "FeatureCollection",
                    features: drawnFeatures,
                };
                downloadGeoJson(geoJson);
            };
            window.saveToDb = () => {
                let geoJsonPolygon = {},
                    geoJsonPolylines = {};
                if (drawnFeatures) {
                    geoJsonPolygon = {
                        type: "FeatureCollection",
                        features: drawnFeatures,
                    };
                    //   localStorage.setItem("featureCollection", JSON.stringify(geoJson))
                    // fetch("http://localhost:4000/geo", {method:"POST", headers:{"Content-Type":"application/json"}, body:JSON.stringify({geoParams:geoJson, id})})
                    // .then(resp=> resp.json())
                    // .then(d => {
                    //     alert("Drawings saved")
                    // })
                }
                if (drawnFeatures1) {
                    geoJsonPolylines = {
                        type: "FeatureCollection",
                        features: drawnFeatures1,
                    };
                    //   localStorage.setItem("featureCollection", JSON.stringify(geoJson))
                }
                let savedLocalData = localStorage.getItem("polyFeatures");
                if (!savedLocalData) {
                    localStorage.setItem(
                        "polyFeatures",
                        JSON.stringify([
                            {
                                polygons: geoJsonPolygon,
                                polylines: geoJsonPolylines,
                                id,
                            },
                        ])
                    );
                } else {
                    let parsedLocal = JSON.parse(savedLocalData);
                    const exists = parsedLocal.find((el) => el.id == id);
                    if (exists) {
                        parsedLocal = parsedLocal.map((el) => {
                            if (el.id == id) {
                                return {
                                    ...el,
                                    polygons: geoJsonPolygon,
                                    polylines: geoJsonPolylines,
                                };
                            }
                            return el;
                        });
                    } else {
                        parsedLocal.push({
                            polygons: geoJsonPolygon,
                            polylines: geoJsonPolylines,
                            id,
                        });
                    }
                    localStorage.setItem(
                        "polyFeatures",
                        JSON.stringify(parsedLocal)
                    );
                }
                alert("Drawigs saved!");
                // fetch("http://localhost:4000/geo", {method:"POST", headers:{"Content-Type":"application/json"}, body:JSON.stringify({polygons:geoJsonPolygon, polylines:geoJsonPolylines, id})})
                // .then(resp=> resp.json())
                // .then(d => {
                //     alert("Drawings saved")
                // })

                // getGeoData();
            };

            window.removeDrawnPoly = () => {
                drawnPolygons?.forEach((polygon) => {
                    polygon.setMap(null);
                    polygon = null;
                });
                drawnPolylines?.forEach((polyline) => {
                    polyline.setMap(null);
                    polyline = null;
                });
                drawnPolylines = [];
                drawnPolygons = [];
            };

            function downloadGeoJson(geoJson) {
                const dataStr =
                    "data:text/json;charset=utf-8," +
                    encodeURIComponent(JSON.stringify(geoJson));
                const downloadAnchorNode = document.createElement("a");
                downloadAnchorNode.setAttribute("href", dataStr);
                downloadAnchorNode.setAttribute("download", "map_data.geojson");
                document.body.appendChild(downloadAnchorNode); // required for firefox
                downloadAnchorNode.click();
                downloadAnchorNode.remove();
            }
            // makeDrawingFromJSON('-', google, map) // uncomment to work again
            window.drawingStart = false;
            initDrawingManager();
            drawingManager.setOptions({
                drawingControl: window.drawingStart,
                drawingMode: "",
            });
            window.toggleDraw = () => {
                try {
                    console.log("drawingManager", drawingManager);
                    if (drawingManager) {
                        // drawingManager.setMap(null);
                        // drawingManager = null;
                        window.drawingStart = !window.drawingStart;
                        drawingManager.setOptions({
                            drawingControl: window.drawingStart,
                            drawingMode: "",
                        });
                    } else {
                        initDrawingManager();
                        // drawingManager
                    }
                } catch (err) {
                    console.log(err.message);
                }
            };

            const overlayTopoTiles = (pth) => {
                const imageMapType = new google.maps.ImageMapType({
                    name: pth,
                    getTileUrl: function (coord, zoom) {
                        var proj = map.getProjection();
                        var tileSize = 256 / Math.pow(2, zoom);
                        var tileBounds = new google.maps.LatLngBounds(
                            proj.fromPointToLatLng(
                                new google.maps.Point(
                                    coord.x * tileSize,
                                    (coord.y + 1) * tileSize
                                )
                            ),
                            proj.fromPointToLatLng(
                                new google.maps.Point(
                                    (coord.x + 1) * tileSize,
                                    coord.y * tileSize
                                )
                            )
                        );

                        if (mapBounds.intersects(tileBounds)) {
                            return [
                                mapParams.root + "/" + pth,
                                "/",
                                zoom,
                                "/",
                                coord.x,
                                "/",
                                Math.pow(2, zoom) - coord.y - 1,
                                ".png",
                            ].join("");
                        }
                        return "";
                    },
                    tileSize: new google.maps.Size(256, 256),
                });
                if (topoOverlays.name !== pth) {
                    setTopoOverlays((prev) => [
                        ...prev,
                        { name: pth, type: imageMapType },
                    ]);
                    map.overlayMapTypes.push(imageMapType);
                }
            };

            const overlayMapTiles = (
                index = 0,
                mapType = "orthoPaths",
                idx
            ) => {
                let imageMapType;
                if (mapType === "volumeSegments") {
                    imageMapType = new google.maps.ImageMapType({
                        name: mapType,
                        // opacity: 0.1,
                        getTileUrl: function (coord, zoom) {
                            var proj = map.getProjection();
                            var tileSize = 256 / Math.pow(2, zoom);
                            var tileBounds = new google.maps.LatLngBounds(
                                proj.fromPointToLatLng(
                                    new google.maps.Point(
                                        coord.x * tileSize,
                                        (coord.y + 1) * tileSize
                                    )
                                ),
                                proj.fromPointToLatLng(
                                    new google.maps.Point(
                                        (coord.x + 1) * tileSize,
                                        coord.y * tileSize
                                    )
                                )
                            );

                            if (mapBounds.intersects(tileBounds)) {
                                return [
                                    mapParams.root +
                                        "/" +
                                        mapParams[mapType][index]["stocks"][
                                            idx
                                        ],
                                    "/",
                                    zoom,
                                    "/",
                                    coord.x,
                                    "/",
                                    Math.pow(2, zoom) - coord.y - 1,
                                    ".png",
                                ].join("");
                            }
                            return "";
                        },
                        tileSize: new google.maps.Size(256, 256),
                    });
                } else {
                    imageMapType = new google.maps.ImageMapType({
                        name: mapType,
                        // opacity: mapType === "orthoPaths" ? orthoMapOpacity : mapType === "DTMPaths" ? DTMMapOpacity : DSMMapOpacity,
                        getTileUrl: function (coord, zoom) {
                            var proj = map.getProjection();
                            var tileSize = 256 / Math.pow(2, zoom);
                            var tileBounds = new google.maps.LatLngBounds(
                                proj.fromPointToLatLng(
                                    new google.maps.Point(
                                        coord.x * tileSize,
                                        (coord.y + 1) * tileSize
                                    )
                                ),
                                proj.fromPointToLatLng(
                                    new google.maps.Point(
                                        (coord.x + 1) * tileSize,
                                        coord.y * tileSize
                                    )
                                )
                            );
                            if (mapBounds.intersects(tileBounds)) {
                                return [
                                    mapParams.root +
                                        "/maps/" +
                                        mapParams[mapType][index] +
                                        "/",
                                    zoom,
                                    "/",
                                    coord.x,
                                    "/",
                                    Math.pow(2, zoom) - coord.y - 1,
                                    ".png",
                                ].join("");
                            }
                            return "";
                        },
                        getTile: function (coord, zoom, ownerDocument) {
                            const div = ownerDocument.createElement("div");
                            div.style.width = "256px";
                            div.style.height = "256px";

                            const img = ownerDocument.createElement("img");
                            img.src = this.getTileUrl(coord, zoom);
                            img.style.width = "256px";
                            img.style.height = "256px";
                            img.style.mixBlendMode = "multiply"; // blending mode here
                            img.style.opacity = "1.0";
                            img.style.position = "absolute";

                            div.appendChild(img);
                            return div;
                        },
                        tileSize: new google.maps.Size(256, 256),
                    });
                }
                map.overlayMapTypes.push(imageMapType);
            };

            // ---------------------- dynamic hillshading -------------------------------------

            const shadeProp = { vert: 1, sunEl: 45, sunAz: 180 };
            class CoordMapType {
                tileSize;
                alt = null;
                maxZoom = 17;
                minZoom = 15;
                name = null;
                projection = null;
                radius = 6378137;
                constructor(tileSize, sunAz, sunEl, vert, typ, pth, clr) {
                    this.tileSize = tileSize;
                    this.sunAz = sunAz;
                    this.sunEl = sunEl;
                    this.vert = vert;
                    this.type = typ;
                    this.pth = pth;
                    this.clr = clr;
                }

                getTile(coord, zoom, ownerDocument) {
                    const tile = ownerDocument.createElement("div");
                    tile.style.width = this.tileSize.width + "px";
                    tile.style.height = this.tileSize.height + "px";

                    const canvas = ownerDocument.createElement("canvas");
                    canvas.width = this.tileSize.width;
                    canvas.height = this.tileSize.height;
                    tile.appendChild(canvas);

                    const ctx = canvas.getContext("2d");

                    let proj = map.getProjection();
                    let tileSize = 256 / Math.pow(2, zoom);
                    let tileBounds = new google.maps.LatLngBounds(
                        proj.fromPointToLatLng(
                            new google.maps.Point(
                                coord.x * tileSize,
                                (coord.y + 1) * tileSize
                            )
                        ),
                        proj.fromPointToLatLng(
                            new google.maps.Point(
                                (coord.x + 1) * tileSize,
                                coord.y * tileSize
                            )
                        )
                    );

                    if (mapBounds.intersects(tileBounds)) {
                        const img = new Image();
                        img.crossOrigin = "anonymous";
                        img.src =
                        
                            `${mapParams.root}/maps/${this.pth}/`  +
                            zoom +
                            "/" +
                            coord.x +
                            "/" +
                            (Math.pow(2, zoom) - coord.y - 1) +
                            ".png";

                        img.onload = () => {
                            const img0 = new Image();
                            img0.crossOrigin = "anonymous";
                            img0.src =
                                `${mapParams.root}/maps/${this.clr}/` +
                                this.type +
                                zoom +
                                "/" +
                                coord.x +
                                "/" +
                                (Math.pow(2, zoom) - coord.y - 1) +
                                ".png";
                            canvas.width = img.width;
                            canvas.height = img.height;
                            ctx.drawImage(img, 0, 0);

                            const imageData = ctx.getImageData(
                                0,
                                0,
                                img.width,
                                img.height
                            );
                            const shaded = shade(
                                [
                                    {
                                        data: imageData.data,
                                        width: img.width,
                                        height: img.height,
                                    },
                                ],
                                {
                                    sunEl: parseFloat(this.sunEl),
                                    sunAz: parseFloat(this.sunAz),
                                    resolution: 1,
                                    vert: parseFloat(this.vert),
                                }
                            );
                            const shadedImageData = new ImageData(
                                shaded.data,
                                shaded.width,
                                shaded.height
                            );
                            ctx.putImageData(shadedImageData, 0, 0);
                            img0.onload = () => {
                                ctx.globalCompositeOperation = "multiply";
                                ctx.drawImage(img0, 0, 0);
                            };
                        };
                    }
                    return tile;
                }

                releaseTile(tile) {}
            }

            function loadNewLayer(newOverlay) {
                map.overlayMapTypes.insertAt(0, newOverlay);
                setTimeout(() => {
                    map.overlayMapTypes.pop();
                }, 500);
            }

            const overlayMapHillshading = (sunShade, mapType) => {
                if (sunShade) {
                    shadeProp[sunShade[0]] = sunShade[1];

                    const newCoordsMapType = new CoordMapType(
                        new google.maps.Size(256, 256),
                        shadeProp.sunAz,
                        shadeProp.sunEl,
                        shadeProp.vert,
                        mapType === "hillshade" ? "h" : "",
                        mapParams.hillshadePaths[window.currentMapTypeIndex].hillshade,
                        mapParams.hillshadePaths[window.currentMapTypeIndex].color
                    );

                    // map.overlayMapTypes.setAt(0, newCoordsMapType);
                    loadNewLayer(newCoordsMapType);
                } else {
                    const coordsMapType = new CoordMapType(
                        new google.maps.Size(256, 256),
                        shadeProp.sunAz,
                        shadeProp.sunEl,
                        shadeProp.vert,
                        mapType === "hillshade" ? "h" : "",
                        mapParams.hillshadePaths[window.currentMapTypeIndex].hillshade,
                        mapParams.hillshadePaths[window.currentMapTypeIndex].color

                    );
                    map.overlayMapTypes.insertAt(0, coordsMapType);
                }
            };

            // ----------------------- end hillshading ---------------------------------------

            const removeOverlayTiles = () => {
                map.overlayMapTypes.forEach((el, i) => {
                    map.overlayMapTypes.removeAt(i);
                });
            };

            const removeTopoTilesLayer = (name) => {
                setTopoOverlays((prev) => {
                    const toRemove = prev.find((l) => l.name === name);
                    if (toRemove) {
                        // Remove it from overlayMapTypes
                        const index = map.overlayMapTypes
                            .getArray()
                            .indexOf(toRemove.type);
                        if (index > -1) {
                            map.overlayMapTypes.removeAt(index);
                        }
                    }
                    return prev.filter((l) => l.name !== name);
                });
            };

            window.removeTilesFromView = () => {
                removeOverlayTiles();
            };
            window.removeTopoFromView = (name) => {
                // removeTopoTilesLayer(name)
                let currType = [];
                for (let drawings of window.drawnFeatures) {
                    if (drawings.pth === name) {
                        drawings.drawing.setMap(null);
                        if (!currType.includes(drawings.type)) {
                            currType.push(drawings.type);
                        }
                    }
                }
                const filterredDrawing = window.drawnFeatures.filter((el) => {
                    return el.pth !== name;
                });
                window.drawnFeatures = filterredDrawing;
                currType = [];
            };

            overlayMapTiles(window.currentMapTypeIndex);
            // window.remove
            window.chnageMapByDate = (index, mapType = "orthoPaths") => {
                removeOverlayTiles();
                // removeOverlayTiles();
                window.currentMapTypeIndex = index;
                sessionStorage.setItem("visit", index)
                setCurrMapTypeIndex(index);
                overlayMapTiles(window.currentMapTypeIndex, mapType);
                setDetectChange((prev) => !prev);
                window.resetPolys();
            };

            window.changeMap = (index, mapType, idx, sunShade = null) => {
                if (!["hillshade", "hillshade2"].includes(mapType)) {
                    removeOverlayTiles();
                }
                if (mapType === "haulPaths") {
                    overlayMapTiles(
                        window.currentMapTypeIndex,
                        "orthoPaths",
                        idx
                    );
                    setTimeout(() => {
                        overlayMapTiles(
                            window.currentMapTypeIndex,
                            mapType,
                            idx
                        );
                    }, 1000);
                    window.currentMapType = mapType;
                    window.resetPolys();
                } else if (
                    mapType === "hillshade" ||
                    mapType === "hillshade2"
                ) {
                    overlayMapHillshading(sunShade, mapType);
                    window.resetPolys();
                } else {
                    overlayMapTiles(window.currentMapTypeIndex, mapType, idx);
                    removeContour();
                    window.currentMapType = mapType;
                    window.resetPolys();
                }
            };
            window.changeTopo = (pth, color) => {
                // overlayTopoTiles(pth)
                makeDrawingFromJSON(pth, google, map, color);
            };

            let mapClickedA = null;
            let mapClickedD = null;
            let mapElevListener = null;
            let aCalInitiated = false;
            let dCalInitiated = false;

            let markers = [];
            let volCoords = [];
            let polygon = null;
            // ----------------------------------------//
            window.startAreaCal = () => {
                if (dCalInitiated) return;
                try {
                    aCalInitiated = true;
                    mapClickedA = map.addListener("click", (mapsMouseEvent) => {
                        const marker = new google.maps.Marker({
                            position: mapsMouseEvent.latLng,
                            map: map,
                            icon: {
                                url: "/dot16.png",
                                anchor: new props.google.maps.Point(8, 8),
                            },
                        });
                        markers.push(marker);
                        if (polygon) {
                            polygon.setMap(null);
                        }
                        drawPolygon();
                        volCoords.push([
                            mapsMouseEvent.latLng.lat(),
                            mapsMouseEvent.latLng.lng(),
                        ]);
                        // volCoords.push([mapsMouseEvent.latLng.lat(),mapsMouseEvent.latLng.lng()])
                        setCoords((prevState) => [
                            ...prevState,
                            [
                                mapsMouseEvent.latLng.lat(),
                                mapsMouseEvent.latLng.lng(),
                            ],
                        ]);
                    });

                    const drawPolygon = () => {
                        const path = markers.map((marker) =>
                            marker.getPosition()
                        );
                        polygon = new google.maps.Polygon({
                            paths: path,
                            strokeColor: "#FF0000",
                            strokeOpacity: 0.8,
                            strokeWeight: 2,
                            fillColor: "#FF0000",
                            fillOpacity: 0.35,
                        });

                        polygon.setMap(map);

                        // Calculate and log the area of the polygon
                        if (google.maps.geometry && polygon) {
                            const area =
                                google.maps.geometry.spherical.computeArea(
                                    polygon.getPath()
                                );
                            document.getElementById("display-label").innerHTML =
                                "-Area-";
                            const areaDiv = document.getElementById("display");
                            areaDiv.innerHTML =
                                (area / 1000).toFixed(2) + "(km<sup>2</sup>)";
                        }
                    };
                } catch (error) {
                    console.log("error");
                }
            };

            window.drawPolygonFromPoints = (coords) => {
                const path = coords.map((coord) => ({
                    lat: coord[0],
                    lng: coord[1],
                }));
                polygon = new google.maps.Polygon({
                    paths: path,
                    strokeColor: "#FF0000",
                    strokeOpacity: 0.8,
                    strokeWeight: 2,
                    fillColor: "#FF0000",
                    fillOpacity: 0.35,
                });

                polygon.setMap(map);
            };

            window.startLineForElevation = () => {
                polyline = new google.maps.Polyline({
                    strokeColor: "#52eb34",
                    strokeOpacity: 1.0,
                    strokeWeight: 3,
                    map: map,
                });

                mapElevListener = map.addListener("click", (event) => {
                    if (lineMarkers.length === 2) return;
                    addMarker(event.latLng);
                    console.log("lineee");
                    if (lineMarkers.length >= 1) {
                        updatePolyline();
                    }
                    setElevCoords((prevState) => [
                        ...prevState,
                        [event.latLng.lat(), event.latLng.lng()],
                    ]);
                });

                function addMarker(location) {
                    const marker = new google.maps.Marker({
                        position: location,
                        map: map,
                        icon: {
                            url: "/dot16.png",
                            scaledSize: new props.google.maps.Size(10, 10),
                            anchor: new props.google.maps.Point(5, 5),
                        },
                    });

                    lineMarkers.push(marker);
                }
                function updatePolyline() {
                    if (polyline) {
                        const path = polyline.getPath();
                        path.push(
                            lineMarkers[lineMarkers.length - 1].getPosition()
                        );
                    }
                }
            };

            let polyline = null;
            let lineMarkers = [];
            window.startLineCal = () => {
                if (aCalInitiated) return;
                try {
                    dCalInitiated = true;
                    polyline = new google.maps.Polyline({
                        strokeColor: "#FF0000",
                        strokeOpacity: 1.0,
                        strokeWeight: 3,
                        map: map,
                    });

                    mapClickedD = map.addListener("click", (event) => {
                        addMarker(event.latLng);
                        if (lineMarkers.length >= 1) {
                            updatePolyline();
                            calculateTotalDistance();
                            displayDistance();
                        }
                    });

                    function addMarker(location) {
                        const marker = new google.maps.Marker({
                            position: location,
                            map: map,
                            icon: {
                                url: "/dot16.png",
                                anchor: new props.google.maps.Point(8, 8),
                            },
                        });

                        lineMarkers.push(marker);
                    }

                    function updatePolyline() {
                        if (polyline) {
                            const path = polyline.getPath();
                            path.push(
                                lineMarkers[
                                    lineMarkers.length - 1
                                ].getPosition()
                            );
                        }
                    }

                    let totalDistance = 0;
                    function calculateTotalDistance() {
                        if (lineMarkers.length > 1) {
                            if (!polyline) {
                                polyline = polyline = new google.maps.Polyline({
                                    strokeColor: "#FF0000",
                                    strokeOpacity: 1.0,
                                    strokeWeight: 3,
                                    map: map,
                                });
                            }
                            const path = polyline.getPath();
                            totalDistance = 0;
                            for (let i = 0; i < path.getLength() - 1; i++) {
                                totalDistance +=
                                    google.maps.geometry.spherical.computeDistanceBetween(
                                        path.getAt(i),
                                        path.getAt(i + 1)
                                    );
                            }
                        }
                    }
                    function displayDistance() {
                        const distDiv = document.getElementById("display");
                        distDiv.innerText =
                            (totalDistance / 1000).toFixed(2) + "km";
                        document.getElementById("display-label").innerText =
                            "Distance";
                        // Alternatively, you can display this distance in an HTML element
                    }
                } catch (error) {
                    console.log(error);
                }
            };
            window.resetPolys = () => {
                setWithinSegVolume(null);
                setCoords([]);
                setElevCoords([]);
                setResHeights([]);
                setCurrPointHeight(0);
                setClickedLatLng({ lat: 0, lng: 0 });
                if (true) {
                    for (let marker of lineMarkers) {
                        marker.setMap(null);
                    }

                    lineMarkers = [];
                    if (polyline) {
                        polyline.setMap(null);
                        polyline = null;
                    }
                    dCalInitiated = false;
                    google.maps.event.removeListener(mapClickedD);
                    mapClickedD = null;
                    // lineDiv.innerText = "Measure Distance";
                    const mesDistDiv = document.getElementById("display");
                    mesDistDiv.innerText = "-";
                }
                if (true) {
                    for (let marker of markers) {
                        marker.setMap(null);
                    }
                    // Clear the markers array
                    markers = [];

                    // Remove the polygon if it exists
                    if (polygon) {
                        polygon.setMap(null);
                        polygon = null;
                    }
                    aCalInitiated = false;
                    google.maps.event.removeListener(mapClickedA);
                    mapClickedA = null;
                    const mesAreaDiv = document.getElementById("display");
                    mesAreaDiv.innerText = "-";
                }
                // window.location.reload();
                google.maps.event.removeListener(mapElevListener);
                mapElevListener = null;
                return true;
            };
        } catch (err) {
            console.log(err.message);
        }
    }, []);

    
    useEffect(() => {
        let getLagLngEvent;
        if (mapRef.current.map && !hasSetMouseMove.current) {
            hasSetMouseMove.current = true;
            getLagLngEvent = mapRef.current.map?.addListener(
                "mousemove",
                (e) => {
                    const lat = e.latLng.lat();
                    const lng = e.latLng.lng();
                    if(window.pointHeightActive) return;
                    setCurrLatLng({
                        lat: `${toDMS(lat)} ${lat >= 0 ? "N" : "S"}`,
                        lng: `${toDMS(lng)} ${lng >= 0 ? "E" : "W"}`,
                    });
                }
            );
        }
        return () => {
            props.google.maps.event.removeListener();
        };
    }, []);

    const listGeneratedContours = () => {
        if (currMapData.hasOwnProperty("tifPaths")) {
            axiosBaseInstance
                .post("/list-contours", {
                    visit: currMapData?.tifPaths[window.currentMapTypeIndex],
                    site: currMapData.name,
                })
                .then((res) => {
                    setContours(res.data);
                })
                .catch((err) => {
                    console.log(err.message);
                    setContours([]);
                });
        }
    };

    useEffect(() => {
        const localContData = JSON.parse(localStorage.getItem("contours"));
        setCreatedContours(localContData);

        listGeneratedContours();
    }, [currMapData, window.currentMapTypeIndex]);

    useEffect(() => {
        let marker;
        if (map && hoveredValue) {
            marker = new props.google.maps.Marker({
                position: hoveredValue,
                map: map,
                icon: {
                    // url: "your-icon-url",
                    scaledSize: new props.google.maps.Size(50, 50),
                    anchor: new props.google.maps.Point(25, 50),
                },
                label: {
                    text: `${hoveredValue.alt.toFixed(2)} m`,
                    color: "black",
                    fontSize: "14px",
                    fontWeight: "bold",
                },
            });

            // Optionally clear the marker on unmount or value change
            return () => {
                setTimeout(() => {
                    marker.setMap(null);
                }, 10);
            };
        }
    }, [hoveredValue, map]);

    return (
        <div className={`${styles.mapPageContainer} mapPage`}>
            <TopNav
                getMap1={window.chnageMapByDate}
                currentMapType={window.currentMapType}
                currentMapTypeIndex={window.currentMapTypeIndex}
                clearContour={removeContour}
                currMapData={currMapData}
                selectOrthoRef={selectOrthoRef}
                style={{ right: "8%", top: "20.5%" }}
            />
            <div className={`${styles.mapPage}`}>
                <div className={`${styles.mapPageSidebar} hideScrollbar`}>
                    <Card
                        renderContour={renderContour}
                        visitId={
                            currMapData &&
                            currMapData.visits &&
                            currMapData.visits.length
                                ? currMapData.visits[window.currentMapTypeIndex]
                                : null
                        }
                        createdContours={createdContours}
                        getContour1={createContour}
                        getContour2={() => createContour(1, "red")}
                        clearContour={removeContour}
                        getMap1={() => window.chnageMap(1)}
                        getMap2={() => window.chnageMap(0)}
                        changeMap={window.changeMap}
                        currentMapTypeIndex={window.currentMapTypeIndex}
                        currentMapType={window.currentMapType}
                        detectChange={detectChange}
                        loading={loading}
                        openModal={openModal}
                        checkedRadio={checkedRadio}
                        setCheckedRadio={setCheckedRadio}
                        checkedRadioMap={checkedRadioMap}
                        setCheckedRadioMap={setCheckedRadioMap}
                        volumeSegments={
                            currMapData && currMapData.volumeSegments
                                ? currMapData.volumeSegments[
                                      window.currentMapTypeIndex
                                  ]
                                : { stocks: [] }
                        }
                        contourPaths={
                            currMapData && currMapData.geoPaths
                                ? currMapData.geoPaths[
                                      window.currentMapTypeIndex
                                  ]
                                : { paths: [] }
                        }
                        topoPaths={
                            currMapData && currMapData.topoPaths
                                ? currMapData.topoPaths[
                                      window.currentMapTypeIndex
                                  ]
                                : { paths: [] }
                        }
                        getSegmentVolume={getSegmentVolume}
                        removeOverlayTiles={window.removeTilesFromView}
                        setSegmentVolume={setSegmentVolume}
                        setWithinSegVolume={setWithinSegVolume}
                        selectOrthoRef={selectOrthoRef}
                        changeTopo={window.changeTopo}
                        removeTopo={window.removeTopoFromView}
                        setLayerIndicator={setLayerIndicator}
                        currMapData={currMapData}
                        contours={contours}
                        setLoading={setLoading}
                        listGeneratedContours={listGeneratedContours}
                    />
                </div>
                <div className={styles.mapPageMainMap}>
                    <VolUploadModal
                        closeModal={closeModal}
                        modalOpen={modalOpen}
                        openModal={openModal}
                    />
                    {/* <Navbar setNavTitle={props.setNavTitle} navTitle={props.navTitle} /> */}
                    {loading && (
                        <div
                            style={{
                                background: "rgba(255, 255, 255, 0.5)",
                                width: "100vw",
                                height: "100vh",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                zIndex: "999999",
                                position: "absolute",
                            }}
                        >
                            <Spinner />
                        </div>
                    )}
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                        }}
                    >
                        {/* TODO: add find location feature */}
                        {/* <div
                            style={{
                                position: "absolute",
                                left: 0,
                                top: 0,
                                zIndex: 3,
                                width: "100px",
                            }}
                        >
                            <input type="text" placeholder="Lat" width="50%" />
                            <input type="text" placeholder="Lng" width="50%" />
                        </div> */}
                        <Map
                            google={props.google}
                            zoom={15}
                            style={mapStyles}
                            streetViewControl={false}
                            // initialCenter={mapCenter}
                            mapTypeControl={true}
                            disableDefaultUI={true}
                            ref={mapRef}
                            maxZoom={21}
                            minZoom={15}
                            drawingControl={true}
                            mapTypeControlOptions={{
                                position:
                                    props.google.maps.ControlPosition
                                        .TOP_CENTER,
                            }}
                        >
                   
                            {currPointHeight !== null &&
                                currPointHeight !== 0 && (
                                    <Marker
                                        position={clickedLatLng}
                                        icon={{
                                            url: markerIcon,
                                            scaledSize:
                                                new props.google.maps.Size(
                                                    50,
                                                    50
                                                ),
                                            anchor: new props.google.maps.Point(
                                                25,
                                                50
                                            ),
                                            labelOrigin:
                                                new props.google.maps.Point(
                                                    30,
                                                    0
                                                ),
                                        }}
                                        label={{
                                            text: `${currPointHeight?.toFixed(
                                                6
                                            )} m`,
                                            color: "black",
                                            fontSize: "14px",
                                            fontWeight: "bold",
                                        }}
                                    />
                                )}
                        </Map>

                        <Card2
                            startLineCal={window.startLineCal}
                            startAreaCal={window.startAreaCal}
                            resetPolys={window.resetPolys}
                            getContour1={createContour}
                            getContour2={() => createContour(1, "red")}
                            clearContour={removeContour}
                            mapId={id}
                            currentMapTypeIndex={window.currentMapTypeIndex}
                            toggleDraw={window.toggleDraw}
                            exportGeoJson={window.exportGeoJson}
                            saveToDb={window.saveToDb}
                            removeDrawnPoly={window.removeDrawnPoly}
                            coords={coords}
                            setCoords={setCoords}
                            drawPolygonFromPoints={window.drawPolygonFromPoints}
                            segmentVolume={segmentVolume}
                            withinSegVolume={withinSegVolume}
                            recenter={window.recenter}
                            removeTopo={window.removeTopoFromView}
                            changeMap={window.changeMap}
                            startLineForElevation={window.startLineForElevation}
                            fetchHeights={fetchHeights}
                            elevCoords={elevCoords}
                            isCollapsed={isCollapsed}
                            drawingProps={drawingProps}
                            handleClickFromList={handleClickFromList}
                            deleteDrawing={deleteDrawing}
                            buildTableHTML={buildTableHTML}
                            toggleDrawingVisibility={toggleDrawingVisibility}
                            // map visit params
                            getMap1={window.chnageMapByDate}
                            currentMapType={window.currentMapType}
                            currMapData={currMapData}
                            selectOrthoRef={selectOrthoRef}
                            // opacity
                            orthoMapOpacity={orthoMapOpacity}
                            DSMMapOpacity={DSMMapOpacity}
                            DTMMapOpacity={DTMMapOpacity}
                            setOrthoMapOpacity={setOrthoMapOpacity}
                            setDSMMapOpacity={setDSMMapOpacity}
                            setDTMMapOpacity={setDTMMapOpacity}
                        />
                    </div>
                    <div
                        id="area-dist"
                        className="container rounded"
                        style={{
                            position: "absolute",
                            zIndex: "9999",
                            bottom: "3%",
                            right: "3.5%",
                            backgroundColor: "white",
                            width: "100px",
                            height: "50px",
                            display: "flex",
                            alignItems: "center",
                            flexDirection: "column",
                            visibility: "hidden",
                        }}
                    >
                        <div id="display-label" className="label">
                            -
                        </div>
                        <div id="display" style={{ fontWeight: "bold" }}>
                            -
                        </div>
                    </div>
                    {elevCoords.length > 1 && resHeights.length > 0 && (
                        <Draggable handle=".drag-handle">
                            <div
                                className="glass-card"
                                style={{
                                    // background: "grey",
                                    width: "50%",
                                    height: "50%",
                                    // position: "absolute",
                                    zIndex: "1",
                                    bottom: "12%",
                                    left: "8%",
                                    translate: "50% 50%",
                                    borderRadius:"4px",
                                    minWidth:"630px"
                                }}
                            >
                                {isDistGraph ? (
                                    <ElevationProfile points={resHeights} />
                                ) : (
                                    <GeoDataChart data={resHeights} />
                                )}
                                <div
                                    style={{
                                        width: "25%",
                                        display: "flex",
                                        position: "absolute",
                                        top: 0,
                                        right: 0,
                                    }}
                                >
                                    {/* <FaHamburger /> */}
                                    <div
                                        className="drag-handle"
                                        style={{
                                            cursor: "move",
                                            width: "50%",
                                            color: "black",
                                            background: "grey",
                                        }}
                                    >
                                        &#10021;
                                    </div>
                                    <div
                                        onClick={() =>
                                            setIsDistGraph((prev) => !prev)
                                        }
                                        style={{
                                            backgroundColor: "cyan",
                                            color: "black",
                                            cursor: "pointer",
                                            width: "25%",
                                        }}
                                    >
                                        &#8644;
                                    </div>
                                    <div
                                        onClick={() => {
                                            window.resetPolys();
                                            setToolIndex(-1)
                                        }}
                                        style={{
                                            width: "25%",
                                            background: "red",
                                            cursor: "pointer",
                                        }}
                                    >
                                        x
                                    </div>
                                </div>
                            </div>
                        </Draggable>
                    )}

                    <Hamburg hideCard={hideCard} isCollapsed={isCollapsed} />
                    <div className={styles.latlngaltOverlay}>
                        <LatLng />
                        <SelectedAltitude currPointHeight={currPointHeight} />
                    </div>
                    <Toolbar
                        startLineCal={window.startLineCal}
                        startAreaCal={window.startAreaCal}
                        resetPolys={window.resetPolys}
                        getContour1={createContour}
                        getContour2={() => createContour(1, "red")}
                        clearContour={removeContour}
                        mapId={id}
                        currentMapTypeIndex={window.currentMapTypeIndex}
                        toggleDraw={window.toggleDraw}
                        exportGeoJson={window.exportGeoJson}
                        saveToDb={window.saveToDb}
                        removeDrawnPoly={window.removeDrawnPoly}
                        coords={coords}
                        setCoords={setCoords}
                        drawPolygonFromPoints={window.drawPolygonFromPoints}
                        segmentVolume={segmentVolume}
                        recenter={window.recenter}
                        removeTopo={window.removeTopoFromView}
                        changeMap={window.changeMap}
                        startLineForElevation={window.startLineForElevation}
                        fetchHeights={fetchHeights}
                        elevCoords={elevCoords}
                        calculateVolumeWithinSegmet={
                            calculateVolumeWithinSegmet
                        }
                        layerIndicator={layerIndicator}
                        isCollapsed={isCollapsed}
                        setPointHeightActive={togglePointHeightActive}
                        pointHeightActive={pointHeightActive}
                        // map visit params
                        getMap1={window.chnageMapByDate}
                        currentMapType={window.currentMapType}
                        currMapData={currMapData}
                        selectOrthoRef={selectOrthoRef}
                        // opacity
                        orthoMapOpacity={orthoMapOpacity}
                        DSMMapOpacity={DSMMapOpacity}
                        DTMMapOpacity={DTMMapOpacity}
                        setOrthoMapOpacity={setOrthoMapOpacity}
                        setDSMMapOpacity={setDSMMapOpacity}
                        setDTMMapOpacity={setDTMMapOpacity}
                        toolIndex={toolIndex}
                        setToolIndex={setToolIndex}
                    />

                    {popupVisible && (
                        <Draggable handle=".draggable-container">
                            <DrawingLabelModal
                                color={color}
                                fillColor={fillColor}
                                handleCancel={handleCancel}
                                handlePropertyChange={handlePropertyChange}
                                handleSave={handleSave}
                                label={label}
                                properties={properties}
                                removeProperty={removeProperty}
                                setColor={setColor}
                                setFillColor={setFillColor}
                                setLabel={setLabel}
                                addProperty={addProperty}
                                strokeOpacity={strokeOpacity}
                                setStrokeOpacity={setStrokeOpacity}
                                strokeWeight={strokeWeight}
                                setStrokeWeight={setStrokeWeight}
                                fillOpacity={fillOpacity}
                                setFillOpacity={setFillOpacity}
                                type={currentShape.type}
                            />
                        </Draggable>
                    )}
                </div>
            </div>
        </div>
    );
};

export default GoogleApiWrapper({
    apiKey: MAPS_API,
    libraries: ["drawing"],
})(MapPage);
